import { useEffect, useState } from "react";
import { Download, Share } from "lucide-react";

let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event("pwa-ready")); });

const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent);

export const InstallButton = () => {
  const [ready, setReady] = useState(!!deferred);
  const [tip, setTip] = useState(false);
  useEffect(() => { const h = () => setReady(true); window.addEventListener("pwa-ready", h); return () => window.removeEventListener("pwa-ready", h); }, []);
  if (standalone()) return null;
  const go = async () => {
    if (deferred) { deferred.prompt(); await deferred.userChoice; deferred = null; setReady(false); return; }
    setTip((t) => !t);
  };
  return (
    <div className="space-y-2">
      <button onClick={go} className="btn-primary w-full" data-testid="install-app-btn"><Download className="w-4 h-4" />Install BTC Odds Watch app</button>
      {tip && <p className="text-xs text-slate-400 leading-relaxed" data-testid="install-tip">
        {isIOS() ? <>In Safari tap <Share className="inline w-3.5 h-3.5" /> <b>Share</b> → <b>Add to Home Screen</b>.</> :
          ready ? "Tap Install again." : <>Open your browser menu (⋮) and choose <b>Install app</b> or <b>Add to Home screen</b>.</>}</p>}
    </div>
  );
};
